export const PLAN_RESTRICTIONS = {
  //Zarządzanie danymi lokalizacji
  CAN_MANAGE_LOCATION_DATA: "can_manage_location_data",
  //Ochrona wizytówek
  CAN_PROTECT_LOCATION_DATA: "can_protect_location_data",
  //Publikacje marketingowe (wpisy, oferty)
  CAN_PUBLISH_MARKETING_PUBLICATIONS: "can_publish_marketing_publications",
  //Automatyczna publikacja zaplanowanych wpisów i ofert
  CAN_PLAN_MARKETING_PUBLICATIONS: "can_plan_marketing_publications",
  //Publikacja zdjęć
  CAN_POST_PHOTOS: "can_post_photos",
  //Odpowiadanie na opinie (manualnie)
  CAN_REPLY_TO_REVIEWS_MANUALLY: "can_reply_to_reviews_manually",
  //Odpowiadanie na opinie (szablony)
  CAN_USE_REVIEW_TEMPLATES: "can_use_review_templates",
  //Odpowiadanie na opinie (AI)
  CAN_USE_AI_REVIEW_REPLY: "can_use_ai_review_reply",
  //Kategoryzacja opinii przez AI (bez sentymentu i bez analityki)
  CAN_USE_AI_REVIEWS_CATEGORIZATION: "can_use_ai_reviews_categorization",
  //Analiza sentymentu (i analityka)
  CAN_USE_SENTIMENT_ANALYSIS: "can_use_sentiment_analysis",
  //Manualne przypisywanie sentymentu
  CAN_MANUALLY_ADD_SENTIMENT: "can_manually_add_sentiment",
  //Monitoring ocen i raporty
  CAN_MONITOR_RATINGS_AND_REPORTS: "can_monitor_ratings_and_reports",
  //Monitoring i raporty akcji użytkowników w GM
  CAN_MONITOR_GMB_ACTIONS_AND_REPORTS: "can_monitor_gmb_actions_and_reports",
  //Analiza SEO - pozycje w wynikach lokalnego wyszukiwania
  CAN_VIEW_SEO_LOCAL_SEARCH_POSITIONS: "can_view_seo_local_search_positions",
  //Analiza SEO - porównanie z konkurencją
  CAN_COMPARE_COMPETITION: "can_compare_competition",
  //Samouczki
  CAN_VIEW_TUTORIALS: "can_view_tutorials",
  //Integracja Bing Maps
  CAN_ENABLE_BING_MAPS: "can_enable_bing_maps",
  CAN_USE_Q_AND_A: "can_use_q_and_a"
};
